import { ProjectModel } from '../models';
import { WriteApiService } from '../services/write-api.service';

/**
 * Projetos pela API.
 *
 * O backend devolve apenas os projetos atribuidos ao usuario -- no caminho
 * anterior o documento vinha inteiro para o browser, com segredo e tudo.
 */
class ProjectRepository {
  static async getById(projectId: string): Promise<ProjectModel | null> {
    return WriteApiService.getProject(projectId);
  }

  static async getAllowed(): Promise<ProjectModel[]> {
    return WriteApiService.listProjects();
  }
}

export { ProjectRepository };
